/*
 * @Description: 
 * @Autor: soul(佘家骏) 
 * @Date: 2021-09-14 18:31:51
 * @LastEditors: soul(佘家骏) 
 * @LastEditTime: 2021-12-28 15:12:53
 */
import yqAnalytics from "yq-analytics"
import router from './router';
import config from './config';
import Vue from 'vue/dist/vue.js';

export default {
  async handlerGetYqAnalyticsPropertyValueBaseData() {
    let propertyValue = {
      // pageUrl 页面路径
      // pageQuery 页面参数
      // pageQueryScene 小程序码scene
      // pageTitle 页面标题
      // mpScene 启动小程序的场景值
      // adPushId 投放Id
      // appId
      // openId 
      // refereeopenid 上级传播者
      // rscuid 传播销售
      // channel 传播渠道
      // projectId 项目Id
      // bizId 业务Id
      // bizType 业务类型 
      // gcj02 国家测量局02号标准坐标系统
      refereeopenid: Vue.prototype.$fopenid,
      channel: Vue.prototype.$channel,
      openId: Vue.prototype.$openid,
      appId: config.APPID,
      bizId: config.bizId,
      projectId: Vue.prototype.$projectId || config.projectId,
      bizType: 'act'
    }
    return new Promise((resolve) => {
      let waitingDataInterval = setInterval(() => {
  
        // pageUrl 页面路径
        try {
          if (!(router && router.currentRoute)) return;
        } catch (e) {
          return;
        }
  
        propertyValue.pageUrl = router.currentRoute?.path;
        if (!propertyValue.pageUrl) {
          return
        }
  
        // pageQuery 页面参数
        if (router.currentRoute.query && Object.keys(router.currentRoute.query).length > 0) {
          propertyValue.pageQuery = JSON.stringify(router.currentRoute.query);
        }
  
        // pageTitle 页面标题
        propertyValue.pageTilte = window.document.title
  
        resolve(propertyValue);
        clearInterval(waitingDataInterval);
      }, 200)
    })
  },
  async handlerYqAnalyticsEvent(eventId, propertyValue) {
    let propertyValueBaseData = await this.handlerGetYqAnalyticsPropertyValueBaseData();
    propertyValueBaseData = {
      ...propertyValueBaseData,
      ...propertyValue
    }
    yqAnalytics.triggerEvent({
      eventId,
      propertyValue: JSON.stringify(propertyValueBaseData)
    })
  },
  handlerYqAnalyticsSetUserInfo() {
    let yqAnalyticsSetUserInfoParams = {}
    if (Vue.prototype.$mobile) {
      yqAnalyticsSetUserInfoParams.phoneNumber = Vue.prototype.$mobile;
    }
    if (Vue.prototype.$openid) {
      yqAnalyticsSetUserInfoParams.openId = Vue.prototype.$openid
      yqAnalytics.setUserInfo(yqAnalyticsSetUserInfoParams)
    }
  }
}